import { Component } from "react";
import { withCookies, ReactCookieProps } from "react-cookie";
import moment from "moment";

interface PageFooterProps {
  className?: string;
}


class PageFooter extends Component<PageFooterProps & ReactCookieProps> {

  private getLastLoginDateTime() {
    const lastLoginDate = this.props.cookies.get("LastLoggedInDate");
    
    if (!lastLoginDate) {
      return "N/A";
    }

    return moment.utc(lastLoginDate).local().format("L LT");
  }

  public render() {
    const classes = `footer page-inner ${this.props.className || ""}`;
    
    return (
      <footer className={classes}>
        <hr className="mtb0" />
        <p className="text-muted"><small><strong>Copyright &copy; 2003-2025 Quest Analytics, L.L.C. All rights reserved.</strong>&nbsp;&nbsp;<i className="fa fa-angle-double-right" />&nbsp;&nbsp;Version&nbsp;{window.buildVersion}&nbsp;&nbsp;Last Login Date: {this.getLastLoginDateTime()} </small></p>
      </footer>
    );
  }
}

export default withCookies(PageFooter);